module.exports = __webpack_public_path__ + "logo-abd05f2a8721a6423f1cf4b12d8a6d7b.png";